import { R as React } from './injectIntl-6b03af4d.js';
import { u as useIntl } from './useIntl-dfb28031.js';
import { a as getIsRunningInChromatic } from './chromatic-b6cfde84.js';
import { C as CircularProgress } from './CircularProgress-4a7bdab3.js';

/** @jsx React.createElement */
const sizeMapping = {
    ['xs']: 12,
    ['s']: 16,
    ['m']: 24,
    ['l']: 32,
    ['xl']: 44,
    ['xxl']: 72,
};
function ApProgressSpinnerReact(props) {
    const { size = 'm', color = 'primary', } = props;
    const isRunningInChromatic = getIsRunningInChromatic();
    const { formatMessage: translate } = useIntl();
    return (React.createElement(CircularProgress, { className: isRunningInChromatic ? 'disable-animations-for-chromatic' : undefined, size: sizeMapping[size], color: color, "aria-label": translate({ id: 'default-progress-spinner' }) }));
}

export { ApProgressSpinnerReact as A };

//# sourceMappingURL=ap-progress-spinner.react-4b9c679b.js.map